import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import {ControllerBase} from "./ControllerBase";
import {BotOpenComposer, BotOpenComposerProps} from "../Views/index";
import {DevPortalAppBase} from "../../DevPortalAppBase";
import { HeaderKind } from "../Utility/HeaderKind";

export class BotOpenComposerController extends ControllerBase {
  component: BotOpenComposer;

  constructor(app: DevPortalAppBase, containerController?: ControllerBase) {
    super(app);
    this.headerKind = HeaderKind.None;
    this.containerController = containerController;
  }

  public load(params: SimpleMvc.QueryParams): void {
    super.load(params);
  }

  private renderPage(botId: string)  {
    const payloadJson = this.params['payload'] || '{}';
    const element = React.createElement(BotOpenComposer, {
      downloadUrl: 'https://docs.microsoft.com/composer/install-composer#install-composer-as-a-desktop-application',
      payload: JSON.parse(payloadJson)
    });
    this.component = ReactDOM.render<BotOpenComposerProps, BotOpenComposer>(element, this.pageContent);

    Rest.BotManagerClient.getById(botId)
    .then(botSubscription => {
        if (!this.isLoaded()) {
            return;
        }

        this.component.setState({bot: botSubscription.Bot})
    });
  }

  protected render(params: SimpleMvc.QueryParams) {
    super.render(params);
    this.renderPage(params['id']);
  }
}



// WEBPACK FOOTER //
// ./Client/v4/Controllers/BotOpenComposerController.ts